import { useContext } from 'react';
import SnackContext from './SnackContext';
import { ISnackContext } from './types';

const useSnackBar = (): ISnackContext => useContext(SnackContext);
export default useSnackBar;
